import React from 'react';
import './spinner.scss'
import { Box, Modal } from '@mui/material';

const SpinnerLoad = (props) => {
    const { open, title } = props;
    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="modal-loader-container">
                <div className="modal-loader-title">
                    <div className="modal-loader-icon-container">
                        <span className="loader"></span>
                    </div>
                    {title &&
                        <h6 className='title-spinner'>{title?.charAt(0)?.toUpperCase() + title?.slice(1)?.toLowerCase()}</h6>
                    }
                </div>
            </Box>
        </Modal>
    );
};

export default SpinnerLoad;